export const NAV = [
  { href: '/#pillars', label: 'What we offer' },
  { href: '/#products', label: 'Software' },
  { href: '/#marketing', label: 'Marketing' },
  { href: '/#pricing', label: 'Pricing' },
  { href: '/#faq', label: 'FAQ' },
];

export const POLICY_LINKS = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/refund-policy', label: 'Refund Policy' },
  { to: '/disclaimer', label: 'Disclaimer' },
];

export const PILLARS = [
  {
    id: 'software',
    eyebrow: 'Design software',
    title: 'Creative tools for every studio',
    text: 'Find software for illustration, interface design, motion, and publishing. Each licence includes download access, seat options, and setup guidance when you need it.',
    points: [
      'Illustration and vector work',
      'Interface and product design',
      'Motion graphics and animation',
      'Layout and print publishing',
    ],
    cta: { href: '/#products', label: 'View design software' },
  },
  {
    id: 'marketing',
    eyebrow: 'Digital marketing',
    title: 'Grow traffic, leads, and sales',
    text: 'Run campaigns, email journeys, search and ads, social publishing, and reporting from one place. Built for freelancers, agencies, and in-house growth teams.',
    points: [
      'Campaign planning and email',
      'Search and paid advertising',
      'Social scheduling and engagement',
      'Analytics and performance reports',
    ],
    cta: { href: '/#marketing', label: 'View marketing tools' },
  },
];

export const PRODUCTS = [
  {
    id: 'illustration',
    name: 'Illustration suite',
    category: 'Design',
    blurb:
      'Draw icons, characters, and brand artwork with precise paths and print-ready export.',
    price: 89,
    badge: 'Popular',
  },
  {
    id: 'ui-design',
    name: 'Interface design suite',
    category: 'Design',
    blurb:
      'Design screens, reusable components, and interactive prototypes for web and apps.',
    price: 99,
    badge: null,
  },
  {
    id: 'motion',
    name: 'Motion graphics suite',
    category: 'Design',
    blurb:
      'Animate timelines for social videos, product demos, and title sequences.',
    price: 109,
    badge: null,
  },
  {
    id: 'layout',
    name: 'Publishing suite',
    category: 'Design',
    blurb:
      'Build multi-page layouts with strong grids and type for decks, posters, and books.',
    price: 79,
    badge: null,
  },
  {
    id: 'digital-marketing',
    name: 'Campaign suite',
    category: 'Marketing',
    blurb:
      'Plan campaigns, map customer journeys, and track results across channels.',
    price: 95,
    badge: 'New',
  },
  {
    id: 'seo-ads',
    name: 'Search & ads suite',
    category: 'Marketing',
    blurb:
      'Research keywords, build ad structures, and review paid and organic performance.',
    price: 85,
    badge: null,
  },
  {
    id: 'social',
    name: 'Social media suite',
    category: 'Marketing',
    blurb:
      'Plan content calendars, schedule posts, and follow engagement on every channel.',
    price: 75,
    badge: null,
  },
  {
    id: 'analytics',
    name: 'Analytics suite',
    category: 'Marketing',
    blurb:
      'Understand audiences, conversions, and campaign ROI with shareable reports.',
    price: 89,
    badge: null,
  },
];

export const CATEGORIES = [
  {
    title: 'Illustration',
    text: 'Create icons, characters, and brand artwork for digital and print.',
  },
  {
    title: 'Interface design',
    text: 'Design websites and apps with reusable components and prototypes.',
  },
  {
    title: 'Motion',
    text: 'Produce short-form animation for social, demos, and presentations.',
  },
  {
    title: 'Publishing',
    text: 'Lay out presentations, posters, and long documents with clean type.',
  },
  {
    title: 'Digital marketing',
    text: 'Launch campaigns, email sequences, and channel plans that convert.',
  },
  {
    title: 'Analytics',
    text: 'Measure traffic, leads, and revenue so every campaign stays accountable.',
  },
];

export const MARKETING_SERVICES = [
  {
    title: 'Campaign management',
    text: 'Organise multi-channel campaigns, owners, deadlines, and creative assets in one workflow.',
  },
  {
    title: 'Email marketing',
    text: 'Build welcome series, nurture sequences, and promotional sends that stay on brand.',
  },
  {
    title: 'Search & paid media',
    text: 'Research demand, structure campaigns, and review results for organic and paid channels.',
  },
  {
    title: 'Social publishing',
    text: 'Schedule posts, track comments and shares, and keep every channel consistent.',
  },
  {
    title: 'Landing pages',
    text: 'Create offer pages and forms that turn design work into measurable leads.',
  },
  {
    title: 'Performance reporting',
    text: 'Share clear dashboards for traffic, conversions, and return on spend.',
  },
];

export const AUDIENCES = [
  {
    title: 'Freelancers',
    text: 'Get a single licence for design or marketing work with fast download and simple renewal.',
  },
  {
    title: 'Creative studios',
    text: 'Share seats across illustration, interface, and motion teams under one studio plan.',
  },
  {
    title: 'Marketing teams',
    text: 'Run campaigns, social, search, and reporting together without juggling separate vendors.',
  },
  {
    title: 'Growing brands',
    text: 'Combine creative production and digital marketing under flexible commercial terms.',
  },
];

export const WHY = [
  {
    title: 'Design and marketing together',
    text: 'Buy creative software and growth tools from one trusted store instead of scattering purchases.',
  },
  {
    title: 'Straightforward licensing',
    text: 'Choose personal, studio, or commercial seats with plain language before you pay.',
  },
  {
    title: 'Fast delivery',
    text: 'Receive download links and activation steps by email as soon as payment clears.',
  },
  {
    title: 'Help when you need it',
    text: 'Get install guidance, licence transfers, and order support from a real team.',
  },
  {
    title: 'Plans that scale',
    text: 'Start with one seat and move to studio or enterprise options as your team grows.',
  },
  {
    title: 'Transparent policies',
    text: 'Privacy, terms, refunds, and disclaimer are published in full and easy to find.',
  },
];

export const STEPS = [
  {
    step: '01',
    title: 'Choose design or marketing',
    text: 'Start with creative software, digital marketing tools, or both under the same account.',
  },
  {
    step: '02',
    title: 'Select your suite',
    text: 'Pick illustration, interface, motion, campaigns, search, social, analytics, and more.',
  },
  {
    step: '03',
    title: 'Confirm your seats',
    text: 'Match the licence to freelance work, a small studio, or a larger organisation.',
  },
  {
    step: '04',
    title: 'Download and get to work',
    text: 'Activate your software and begin designing, publishing, or running campaigns.',
  },
];

export const PLANS = [
  {
    name: 'Single seat',
    price: 'From $69',
    detail: 'Ideal for freelancers and independent creators or marketers.',
    points: ['1 activation', 'Email support', 'Updates for 12 months'],
  },
  {
    name: 'Studio',
    price: 'From $189',
    detail: 'Best for small teams sharing design and marketing software.',
    points: ['Up to 5 seats', 'Priority chat support', 'Shared licence portal'],
    featured: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    detail: 'Volume licensing, invoicing, and onboarding for larger organisations.',
    points: ['Flexible seat counts', 'Dedicated account manager', 'Custom agreements'],
  },
];

export const FAQS = [
  {
    q: 'What can I buy on GearsZone?',
    a: 'GearsZone sells design software for illustration, interface, motion, and publishing, plus digital marketing tools for campaigns, email, search, social, and analytics.',
  },
  {
    q: 'Can I purchase design and marketing software together?',
    a: 'Yes. Many customers keep creative and growth tools under one studio or enterprise plan for simpler billing and renewals.',
  },
  {
    q: 'How do I receive my purchase?',
    a: 'After checkout we email a secure download link and activation instructions. Most software runs on Windows and macOS.',
  },
  {
    q: 'Can I upgrade my licence later?',
    a: 'Yes. You can move from a single seat to a studio plan as your team grows. Eligible upgrades may receive credit for unused time.',
  },
  {
    q: 'Do you offer installation help?',
    a: 'Yes. Our support team can help with download issues, activation, and basic setup questions after purchase.',
  },
  {
    q: 'Where can I read your policies?',
    a: 'Privacy Policy, Terms of Service, Refund Policy, and Disclaimer are linked in the footer of every page.',
  },
];
